var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrenyIconEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3425 15.9711C9.50278 15.9719 8.67904 15.745 7.96142 15.3154C7.2438 14.8858 6.65996 14.2701 6.2738 13.5354H10.3425L11.0489 12.1436H5.80759C5.77227 11.914 5.75108 11.6843 5.75108 11.4477C5.75108 11.2111 5.77227 10.9815 5.80759 10.7518H10.3425L11.0489 9.36001H6.2738C6.66058 8.62591 7.24457 8.01054 7.96205 7.58103C8.67952 7.15152 9.50294 6.92436 10.3425 6.92434C11.4798 6.92434 12.5252 7.33492 13.3304 8.01691L14.5807 6.78516C13.4174 5.75374 11.9075 5.18351 10.3425 5.18457C7.57352 5.18457 5.22837 6.9313 4.35247 9.36001H1.86604L1.15967 10.7518H4.02754C3.97059 11.2141 3.97059 11.6814 4.02754 12.1436H1.86604L1.15967 13.5354H4.35247C5.22837 15.9642 7.57352 17.7109 10.3425 17.7109C11.9742 17.7109 13.4576 17.1054 14.5807 16.1103L13.3234 14.8785C12.5252 15.5605 11.4868 15.9711 10.3425 15.9711Z",
    fill: "#A3EB64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7913 11.4479H18.1597M15.4755 14.1321V8.76367",
    stroke: "#A3EB64",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrenyIconEuro);
export default __webpack_public_path__ + "static/media/curreny-icon-euro.269be1695786743a745e9de91221489d.svg";
export { ForwardRef as ReactComponent };